import { Headline3, Meta, theme } from 'aimo-ui';
import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { TextRow } from 'screens/prepaidTickets/PrepaidTicket';
import { Divider } from 'styles/CommonLayoutStyles';
import { StyledWrapper } from 'styles/ContainerStyles';
import {
  CountryCode,
  Maybe,
  RefundHistoryItem,
} from 'types/generatedSchemaTypes';
import { currencyFormatter, getLocale } from 'utils/commonUtils';

interface RefundHistoryProps {
  refundData: Maybe<RefundHistoryItem>[];
  countryCode: CountryCode;
}

const RefundHistoryList: React.FC<RefundHistoryProps> = ({
  refundData,
  countryCode,
}) => {
  const { t } = useTranslation();
  const dateFormat = (date: Date) =>
    format(new Date(date), 'dd.MM.yyyy HH:mm', {
      locale: getLocale(),
    });
  return (
    <StyledWrapper>
      <StyledWrapper mb={10}>
        <Headline3>{t('parking.receipt.refundHistory.refundTitle')}</Headline3>
      </StyledWrapper>
      {refundData.map((refund, i, arr) => (
        <View key={`receipt-refund-item-${i}`}>
          <TextRow marginTop>
            <Meta color={theme.colors.gray300}>
              {t('parking.receipt.refundHistory.refundDateTitle')}
            </Meta>
            <Meta testID={`receipt-refund-date-${i}`}>
              {refund?.timestamp && dateFormat(refund.timestamp || '')}
            </Meta>
          </TextRow>
          <TextRow marginTop>
            <Meta color={theme.colors.gray300}>
              {t('parking.receipt.refundHistory.refundAmount')}
            </Meta>
            <Meta
              color={theme.colors.boost.green}
              testID={`receipt-refund-amount-${i}`}>
              {currencyFormatter(
                (refund?.refundedAmountCents || 0) / 100,
                countryCode
              )}
            </Meta>
          </TextRow>
          {i < arr.length - 1 && <Divider marginVertical={5} />}
        </View>
      ))}
    </StyledWrapper>
  );
};

export default RefundHistoryList;
